import { arrayToObject, deleteProperty } from "@/services/helpers";

export const reset = (state, payload) => {
  state.list = {};
};

export const init = (state, payload) => {
  state.list = arrayToObject(payload.buyerStages, "id");
};

export const addBuyerStage = (state, payload) => {
  state.list = { ...state.list, [payload.id]: payload };
};

export const updateBuyerStage = (state, payload) => {
  state.list[payload.id] = { ...state.list[payload.id], ...payload };
};

export const processDeletedBuyerStage = (state, payload) => {
  const deletedBuyerStagePayload = payload.deletedBuyerStage;
  state.list = deleteProperty(state.list, deletedBuyerStagePayload.id.toString());
};
